import Textarea from '../../../Common/ui/textArea'
import { Pagination, Popover, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import AddSquareIcon from '../../../Common/Icon/AddSquareIcon'
import '../../../Styles/ChecklistQuestions.css'
import { cn } from 'src/lib/utils'
import { useLocation } from 'react-router'
import { useTranslation } from 'react-i18next'
import ContentCircle from 'src/Common/ui/contentCircle'
import { CHECKLIST_KEY } from 'src/Entities/Governance'
import { RiCalendar2Line } from 'react-icons/ri'

function ChecklistQuestions ({ activeTab, handleDateChange, timeline = 0, inputValidation, control, data, errors, onInputChangeTextArea, onInputChange, handleAddControls, handleDeleteControls }) {
    const location = useLocation()
    const viewCondition = () => {
        const path = location.pathname
        if (path.includes('Add') || path.includes('Edit')) {
            return false
        } else {
            return true
        }
    }
    const [ paginatedData, setPaginatedData ] = useState([])
    const [ currentPage, setCurrentPage ] = useState(1)

    const rowsPerPage = 5
    const totalPages = Math.ceil(data.length / rowsPerPage)
    const handlePageChange = (event, value) => {
        setCurrentPage(value)
    }

    useEffect(() => {
        if (data.length > 0) {
            if (viewCondition()) {
                setPaginatedData(data.map((item, i) => ({ ...item, sNo: i + 1 })).slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage))
            } else {
                setPaginatedData(data.map((item, i) => ({ ...item, sNo: i + 1 })))
            }
        }
    }, [ data, currentPage ])
    const { t } = useTranslation()
    const [ disable, setDisable ] = useState(false)

    useEffect(() => {
        if (!viewCondition() && paginatedData.length > 0) {
            const find = paginatedData.every((ele) => {
                return ele.actions &&
                ele.taskOnDue
                // &&
                // ele.penaltyAndFines &&
                // ele.damageToReputation
            })
            if (find) {
                setDisable(false)
            } else {
                setDisable(true)
            }
        }
    }, [paginatedData])
    const [ entries, setEntries ] = useState({
        entry: 0,
        from: 0,
        to: 0
    })
    useEffect(() => {
        setEntries({
            entry: data?.length,
            from: (currentPage - 1) * rowsPerPage + 1,
            to: (currentPage - 1) * rowsPerPage + paginatedData?.length - 1 + 1
        })
    }, [paginatedData])
    const [ isOpen, setIsOpen ] = useState(false)
    const handleClick = (event, day, index) => {
        setIsOpen(event.currentTarget)
        setSelectedDay(day)
        handleDateChange(day, CHECKLIST_KEY, index)
        setCheckInd(index)
    }
    const handleClose = () => {
        setIsOpen(null)
    }
    const [ selectedDay, setSelectedDay ] = useState(null)
    const [ checkInd, setCheckInd ] = useState(0)
    const handleSelectDay = (day) => {
        setSelectedDay(day)
        handleDateChange(day, CHECKLIST_KEY, checkInd)
        setIsOpen(null)
    }
    return (
        <> {<div style={{ display: activeTab === 4 ? 'block' : 'none', height: '100%' }}>
            <div className='h-[86%]'>
                <TableContainer className='checklist-comp-table !global-table'>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {/* <TableCell sx={{ border: 'none' }} colSpan={2}></TableCell>
                                <TableCell align='center' colSpan={2}>{'Risk of Non-Compliance limit'}</TableCell> */}
                            </TableRow>
                            <TableRow>
                                <TableCell align='center'>{'#'}</TableCell>
                                <TableCell align='center'><p className={cn('pl-2')}>{t('Actions')}</p></TableCell>
                                <TableCell align='center'><p className={cn('pl-2')}>{t('Due on')}</p></TableCell>
                                {/* <TableCell align='center'><p className={cn('pl-2')}>{t('Penalties and fines')}</p></TableCell>
                                <TableCell align='center'><p className={cn('pl-2')}>{t('Damage to reputation')}</p></TableCell> */}
                                {data.length > 1 && !viewCondition() && <TableCell></TableCell>}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                (viewCondition() ? paginatedData : data)?.map((item, j) => {
                                    item.sNo = j + 1
                                    return (
                                        <>
                                            <TableRow key={j}>

                                                <TableCell align='center'><div className='w-full flex justify-center'>
                                                    <ContentCircle className={'min-h-6 text-center bg-[hsl(var(--primary-table-head))] min-w-6'} contentClassName={'text-primary text-sm'} content={item.sNo} />

                                                </div></TableCell>
                                                <TableCell align='center'>
                                                    <p className={cn('checklist-comp-table-td')}>
                                                        {viewCondition()
                                                            ? <div>{item.actions}</div>
                                                            : <Textarea
                                                                errors={errors}
                                                                control={control}
                                                                required
                                                                rules={{
                                                                    validate: (value) => {
                                                                        return inputValidation(value, value?.length < 251, 'This field is required', 'Characters should be less than 250')
                                                                    }
                                                                }}
                                                                name={`checkLIst-actions-${j}`}
                                                                placeholder={t('Enter Action')}
                                                                type="text"
                                                                onValueChange={(e) => onInputChangeTextArea(e, `checkLIst-actions-${j}`)}
                                                                value={item.actions}
                                                                className='!border-none !ring-0 !shadow-none !h-14 !p-0'
                                                                maxLength={250}
                                                            />}
                                                    </p>
                                                </TableCell>
                                                {/* <TableCell align='center'>
                                                    <p className={cn('checklist-comp-table-td')}>
                                                        {viewCondition()
                                                            ? <div>{item.penaltyAndFines}</div>
                                                            : <Textarea
                                                                errors={errors}
                                                                control={control}
                                                                required
                                                                rules={{
                                                                    validate: (value) => {
                                                                        return inputValidation(value, value?.length < 251, 'This field is required', 'Characters should be less than 250')
                                                                    }
                                                                }}
                                                                name={`checkLIst-penaltyAndFines-${j}`}
                                                                placeholder={t('Enter Penalty And Fines')}
                                                                type="text"
                                                                onValueChange={(e) => onInputChangeTextArea(e, `checkLIst-penaltyAndFines-${j}`)}
                                                                value={item.penaltyAndFines}
                                                                defaultValue={item.penaltyAndFines}
                                                                className='!border-none !ring-0 !shadow-none !h-14 !p-0'
                                                                maxLength={250}
                                                            />}
                                                    </p>
                                                </TableCell>
                                                <TableCell align='center'>
                                                    <p className={cn('checklist-comp-table-td')}>
                                                        {viewCondition()
                                                            ? <div>{item.damageToReputation}</div>
                                                            : <Textarea
                                                                errors={errors}
                                                                control={control}
                                                                required
                                                                rules={{
                                                                    validate: (value) => {
                                                                        return inputValidation(value, value?.length < 251, 'This field is required', 'Characters should be less than 250')
                                                                    }
                                                                }}
                                                                name={`checkLIst-damageToReputation-${j}`}
                                                                placeholder={t('Enter Damage To Reputation')}
                                                                type="text"
                                                                onValueChange={(e) => onInputChangeTextArea(e, `checkLIst-damageToReputation-${j}`)}
                                                                value={item.damageToReputation}
                                                                defaultValue={item.damageToReputation}
                                                                className='!border-none !ring-0 !shadow-none !h-14 !p-0'
                                                                maxLength={250}
                                                            />}
                                                    </p>
                                                </TableCell> */}
                                                <TableCell align='center'>
                                                    <p className={cn('checklist-comp-table-td')}>
                                                        {viewCondition()
                                                            ? <div>{item.taskOnDue}</div>
                                                            : <>
                                                                <div className='flex justify-center gap-2' ><span>{item.taskOnDue}</span> <RiCalendar2Line className='cursor-pointer' onClick={(e) => handleClick(e, item.taskOnDue, j)} size={17} color="hsl(var(--primary))"/></div>
                                                            </>
                                                        }
                                                    </p>
                                                </TableCell>
                                                {data.length > 1 && !viewCondition() && <TableCell><div className='cursor-pointer' onClick={() => handleDeleteControls('checkLIst', j)}><img src='/Common/Icon/DeleteIconGov.svg' className='w-[25px] h-[25px]' /></div></TableCell>}
                                            </TableRow>
                                        </>
                                    )
                                })
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            <Popover
                open={Boolean(isOpen)}
                anchorEl={isOpen}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left'
                }}
            >
                <div className="grid p-3 grid-cols-7 gap-2">
                    {Array.from({ length: 31 }, (_, i) => i + 1).map((day) => (
                        <button
                            key={day}
                            style={{ pointerEvents: day <= timeline ? '' : 'none', cursor: day <= timeline ? 'pointer' : 'not-allowed', background: selectedDay === day ? 'hsl(var(--primary))' : '', color: selectedDay === day ? 'hsl(var(--card))' : '' }}
                            className={cn(`w-10 h-9 rounded-full ${
                         'hover:bg-gray-200'
                      }`)}
                            onClick={() => handleSelectDay(day)}
                        >
                            {day}
                        </button>
                    ))}
                </div>
            </Popover>
            {viewCondition() && data.length > 0 && <div className="border-t-2 border-t-primary-foreground flex items-center justify-between mt-2 p-4 h-[16%]">
                <Typography className="text-muted !text-h4">
                        Showing data {entries.from} to {entries.to} of {entries.entry} entries
                </Typography>
                <Pagination
                    sx={{ marginLeft: 'auto' }}
                    count={totalPages}
                    page={currentPage}
                    onChange={handlePageChange}
                    variant="outlined"
                    shape="rounded" />
            </div>}
            {!viewCondition() && <div className='w-full flex justify-end mt-5 pr-1 cursor-pointer'>
                <div className={cn(disable ? 'bg-popover pr-1 rounded-sm !text-card pointer-events-none' : '', 'flex gap-2 items-center text-primary')} onClick={() => { handleAddControls('checkLIst') }}><AddSquareIcon fill={disable ? 'hsl(var(--card))' : 'hsl(var(--primary))'} /> <span>New</span></div>

                {/* <div className='flex gap-2 items-center text-primary' onClick={() => { handleAddControls('checkLIst') } }><AddSquareIcon /> <span>New</span></div> */}
            </div>}
        </div>} </>
    )
}

ChecklistQuestions.propTypes = {
    controls: PropTypes.any,
    control: PropTypes.any,
    errors: PropTypes.any,
    data: PropTypes.any,
    onInputChangeTextArea: PropTypes.func,
    onInputChange: PropTypes.func,
    handleAddControls: PropTypes.func,
    handleDeleteControls: PropTypes.func,
    activeTab: PropTypes.any,
    inputValidation: PropTypes.any
}

export default ChecklistQuestions
